import { render, staticRenderFns } from "./GroupOverviewApp.vue?vue&type=template&id=1d5dd94c&scoped=true"
import script from "./GroupOverviewApp.vue?vue&type=script&lang=js"
export * from "./GroupOverviewApp.vue?vue&type=script&lang=js"
import style0 from "./GroupOverviewApp.vue?vue&type=style&index=0&id=1d5dd94c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5dd94c",
  null
  
)

export default component.exports